import { render, staticRenderFns } from "./IntellectualProperty.vue?vue&type=template&id=37fa0225&scoped=true&"
import script from "./IntellectualProperty.vue?vue&type=script&lang=js&"
export * from "./IntellectualProperty.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/project-manage.css?vue&type=style&index=0&id=37fa0225&scoped=true&lang=css&"
import style1 from "./IntellectualProperty.vue?vue&type=style&index=1&id=37fa0225&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fa0225",
  null
  
)

export default component.exports